import http from "@/services/http";

export async function fetch(invoiceRequest: any) {
  const { data } = await http().post(
    window.env.COMMERCE_API + "/download-invoice",
    invoiceRequest
  );
  return data;
}
